import { Component } from '@angular/core';

@Component({
  selector: 'pdf-debug-dialog',
  templateUrl: './pdf-debug-dialog.component.html',
  styles: ``
})
export class PdfDebugDialogComponent {
  public isShowing = false;
}
